import { LoginDto } from "../../types/auth";

enum LocalStorageKey {
  FASOO_ECO_TOKEN = "fasoo-eco-token",
  FASOO_ECO_USER = "fasoo-eco-user",
  FASOO_ECO_ADMIN_TOKEN = "fasoo-eco-admin-token",
  FASOO_ECO_ADMIN = "fasoo-eco-admin",
}
export const setAccessToken = (token: string): void => {
  return window.localStorage.setItem(LocalStorageKey.FASOO_ECO_TOKEN, token);
};
export const getAccessToken = (): string | null => {
  return window.localStorage.getItem(LocalStorageKey.FASOO_ECO_TOKEN);
};
export const removeAccessToken = (): void => {
  return window.localStorage.removeItem(LocalStorageKey.FASOO_ECO_TOKEN);
};

export const setUserInfoFromLocalStorage = (userInfo: LoginDto): void => {
  return window.localStorage.setItem(
    LocalStorageKey.FASOO_ECO_USER,
    JSON.stringify(userInfo)
  );
};
export const getUserInfoFromLocalStorage = (): string | null => {
  return window.localStorage.getItem(LocalStorageKey.FASOO_ECO_USER);
};
export const removeUserInfoFromLocalStorage = (): void => {
  return window.localStorage.removeItem(LocalStorageKey.FASOO_ECO_USER);
};

export const setAccessAdminToken = (token: string): void => {
  return window.localStorage.setItem(
    LocalStorageKey.FASOO_ECO_ADMIN_TOKEN,
    token
  );
};
export const getAccessAdminToken = (): string | null => {
  return window.localStorage.getItem(LocalStorageKey.FASOO_ECO_ADMIN_TOKEN);
};
export const removeAccessAdminToken = (): void => {
  return window.localStorage.removeItem(LocalStorageKey.FASOO_ECO_ADMIN_TOKEN);
};

export const setAdminInfoFromLocalStorage = (userInfo: any): void => {
  return window.localStorage.setItem(
    LocalStorageKey.FASOO_ECO_ADMIN,
    JSON.stringify(userInfo)
  );
};
export const getAdminInfoFromLocalStorage = (): string | null => {
  return window.localStorage.getItem(LocalStorageKey.FASOO_ECO_ADMIN);
};
export const removeAdminInfoFromLocalStorage = (): void => {
  return window.localStorage.removeItem(LocalStorageKey.FASOO_ECO_ADMIN);
};
export const setRedirectUrl = (redirectUrl: string): void => {
  if (redirectUrl.includes("/login")) return;
  return window.sessionStorage.setItem("redirectUrl", redirectUrl);
};
export const getRedirectUrl = (): string | null => {
  return window.sessionStorage.getItem("redirectUrl");
};
export const removeRedirectUrl = (): void => {
  return window.sessionStorage.removeItem("redirectUrl");
};
export const getWorkspaceCode = (): string | null => {
  return window.sessionStorage.getItem("fasoo-workspace-code");
};
export const setWorkspaceCode = (dsdCode: string): void => {
  return window.sessionStorage.setItem("fasoo-workspace-code", dsdCode);
};
export const removeWorkspaceCode = (): void => {
  return window.sessionStorage.removeItem("fasoo-workspace-code");
};
export const removeWorkspaceName = (): void => {
  return window.sessionStorage.removeItem("fasoo-workspace-name");
};
export const getWorkspaceName = (): string | null => {
  return window.sessionStorage.getItem("fasoo-workspace-name");
};
export const setWorkspaceName = (workspaceName: string): void => {
  return window.sessionStorage.setItem("fasoo-workspace-name", workspaceName);
};
